<template>
<!--  <w-action-sheet :action-sheet-state="exportState" @handleClose="closeWindow">-->
<!--    <div slot="action-sheet-content" class="export-content flex-column">-->
<!--      <span class="export-title">保存简历至</span>-->
<!--      <div class="tab flex-between">-->
<!--        <div v-for="item in exportList" :key="item.type" class="item flex-column-center" @click="exportCv(item)">-->
<!--          <div class="icon-wrapper flex-center" :class="`icon-${item.type}`">-->
<!--            <span :class="`iconfont ${item.icon}`"/>-->
<!--          </div>-->
<!--          <span class="label">{{ item.label }}</span>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </w-action-sheet>-->
  <w-popup-show :state="exportState" @handleClose="closeWindow">
    <div slot="content" class="export-popup-content flex-column">
      <div class="export-title flex-center">简历保存至</div>
      <div class="is-hidden-message flex-between" @click="hideMessage">
        <span>隐藏联系方式</span>
        <!-- <div class="checked" v-if="!hideProfile"></div>
        <span class="iconfont iconwancheng" v-else></span>
        <span>导出后隐藏个人信息</span> -->
        <div @click.prevent="changeSwitchValue('visibility_type')">
          <cube-switch v-model="visibilityType" :class="{'switch-close': !visibilityType}"></cube-switch>
        </div>
      </div>
      <div class="tab-container flex-between">
        <template v-for="(item, index) in exportList">
          <div class="export-tab-item flex-column-center" :key="index" @click="exportCv(item)">
            <div class="icon-wrapper flex-center" :class="`icon-${item.type}`">
              <!-- <span :class="`iconfont ${item.icon}`"></span> -->
              <img :src="item.icon" alt="">
            </div>
            <span class="label">{{ item.label }}</span>
            <div v-if="item.type === 'local' || item.type === 'pic'" class="right-top-right">暂不支持</div>
          </div>
        </template>
      </div>
      <!-- <div class="cancel-content flex-center" @click="closeWindow">取消</div> -->
    </div>
  </w-popup-show>
</template>

<script>
	import WPopupShow from '../../components/global/w-popup-show'
  import WActionSheet from '../../components/global/w-action-sheet'
	import { envMixin } from '../../assets/js/mixin/global'

	export default {
		name: 'cv-export',
		mixins: [ envMixin ],
		props: {
			exportState: {
				type: Boolean,
				default: false
			},
      cvSettings: {
        type: Object,
        default: () => {}
      }
		},
		data () {
			return {
        hideProfile: false,
        visibilityType: this.cvSettings.visibility_type === 10
      }
		},
		mounted () {
		},
		computed: {
			exportList () {
        let exportList = [
						{ label: '邮箱', icon: 'https://files.wondercv.com/cv-share/email.png', type: 'email' },
					];
				if (this.isIos) {
          exportList.unshift({ label: '微信', icon: 'https://files.wondercv.com/cv-share/weixin.png', type: 'wechat' })
          exportList.push({ label: '本地', icon: 'https://files.wondercv.com/cv-share/file.png', type: 'local' });
					return exportList
				} else {
          exportList.push({ label: '图片', icon: 'https://files.wondercv.com/cv-share/image.png', type: 'pic' });
          //非支付宝/夸克/uc
          if(!(this.isAlipayClient || this.isUCClient || this.isQuaReClient)){
            exportList.unshift({ label: '微信', icon: 'https://files.wondercv.com/cv-share/weixin.png', type: 'wechat' })
            exportList.push({ label: '本地', icon: 'https://files.wondercv.com/cv-share/file.png', type: 'local' });
          }
					return exportList
				}
			}
		},
		watch: {
      'cvSettings.visibility_type': {
        handler(newVal, oldVal) {
          this.visibilityType = newVal === 10
        },
      }
    },
		components: {
			WPopupShow,
      WActionSheet
		},
		methods: {
		  // 隐藏信息选项
      hideMessage() {
        this.hideProfile = !this.hideProfile;
      },
      changeSwitchValue() {
        this.$emit('changeSwitchValue', 'visibility_type')
      },
			closeWindow () {
				this.$emit('closeWindow')
			},
			exportCv (item) {
				this.$emit('exportCv', item, this.hideProfile)
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/global/variable';
  @import '../../assets/scss/global/mixin';
  .export-popup-content {
    width: 100vw;
    .export-title {
      text-align: center;
      padding: 28px 0 20px;
      color: $color-title;
      border-bottom: 6px solid #f9f9f9;
    }
    .is-hidden-message {
      height: 52px;
      margin: 0 24px;
      color: $color-title;
      border-bottom: 1px solid #f9f9f9;
      .checked {
        width: 14px;
        height: 14px;
        box-sizing: border-box;
        border-radius: 50%;
        border: 1px solid #9C9C9C;
        margin-right: 6px;
      }
      .iconfont {
        font-size: 14px;
        color: #ff6644;
        margin-right: 6px;
      }
      .switch-close {
        ::v-deep .cube-switch-ui::before {
          background-color: #CFCFCF;
        }
      }
      ::v-deep .cube-switch .cube-switch-input:checked + .cube-switch-ui::after {
        transform: translateX(26px);
      }
      ::v-deep .cube-switch-ui {
        width: 48px;
        height: 22px;
        &:after {
          width: 22px;
        }
      }
    }
    .tab-container {
      padding: 30px 38px 0;
      @include ipx-content-bottom(30px);
      .export-tab-item {
        position: relative;
        .right-top-right {
          position: absolute;
          display: flex;
          align-items: center;
          top: -10px;
          right: -35px;
          padding: 0 12px;
          height: 18px;
          border-radius: 4px 4px 4px 0px;
          border: 1px solid #E5E6EC;
          background: #F2F3F5;
          font-size: 10px;
          color: #84909D;
        }
      }
    }
    .cancel-content {
      padding: 36px 25px 28px;
      @include ipx-content-bottom(28px);
      font-size: $font-size-medium-x;
      color: #9c9c9c;
      width: 100%;
    }
  }
  .icon-wrapper {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    // margin-bottom: 4px;
    // background-color: #F9F9F9;
    color: #9C9C9C;
    .export-icon {
      width: 24px;
    }
    img {
      width: 60px;
      height: 60px;
    }
  }
  .iconfont {
    font-size: 30px;
    font-weight: 400;
    background-color: #F9F9F9;
  }
  .icon-wechat {
    color: #01DD6C;
  }
  .icon-email {
    color: #5AA2FF;
  }
  .icon-local {
    color: #FF6644;
  }
  .icon-pic {
    color: #FFD100;
  }
  .label {
    font-size: $font-size-small;
    color: $color-dark-gray;
  }
</style>
